<a [routerLink]="['/channels/details', item.id, item.name | slugify]" >
  <img [src]="item.id | HosChannelImageUrl:500" alt="{{ item.name }}" aria-hidden="true">
  <h3>{{ item.name }}</h3>
  <p>{{ item.description }}</p>
</a>
